import { render, staticRenderFns } from "./registerExport.vue?vue&type=template&id=54f8464e&scoped=true&"
import script from "./registerExport.vue?vue&type=script&lang=js&"
export * from "./registerExport.vue?vue&type=script&lang=js&"
import style0 from "./registerExport.vue?vue&type=style&index=0&id=54f8464e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f8464e",
  null
  
)

export default component.exports